import { useEffect, useState } from "react";
import { useReducedMotion } from "framer-motion";
import { Pause, Play } from "lucide-react";

const photos = [
  { file: "hero-engineer.webp", label: "Installation" },
  { file: "home-repairs.webp", label: "Repairs" },
  { file: "home-maintenance-gauges.webp", label: "Maintenance" },
  { file: "sauna-assembly.webp", label: "Sauna installation" },
  { file: "we-supply-delivery.webp", label: "Supply" },
];

export function HeroBackground() {
  const reduce = useReducedMotion();
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused || reduce) return;
    const timer = window.setInterval(() => {
      if (!document.hidden) setActive(index => (index + 1) % photos.length);
    }, 6000);
    return () => window.clearInterval(timer);
  }, [paused, reduce]);

  return (
    <>
      <div aria-hidden="true" className="absolute inset-0 pointer-events-none overflow-hidden">
        {photos.map((photo, index) => (
          <img key={photo.file} src={`${import.meta.env.BASE_URL}images/${photo.file}`}
            alt="" fetchPriority={index === 0 ? "high" : "low"} decoding="async"
            className="absolute inset-0 h-full w-full object-cover object-top motion-safe:transition-opacity motion-safe:duration-1000"
            style={{ opacity: active === index ? 0.2 : 0 }} />
        ))}
      </div>
      <div className="absolute bottom-4 left-0 right-0 z-10 flex items-center justify-center gap-3">
        <div className="flex items-center gap-2" role="group" aria-label="Background photos">
          {photos.map((photo, index) => (
            <button key={photo.file} type="button" aria-label={`Show ${photo.label.toLowerCase()} photo`}
              aria-pressed={active === index} onClick={() => { setActive(index); setPaused(true); }}
              className="flex h-8 w-8 items-center justify-center rounded-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-white">
              <span className={`h-1.5 rounded-full ${active === index ? "w-6 bg-white" : "w-1.5 bg-white/40"}`} />
            </button>
          ))}
        </div>
        {!reduce && (
          <button type="button" onClick={() => setPaused(value => !value)}
            aria-label={paused ? "Play background slideshow" : "Pause background slideshow"}
            className="grid h-8 w-8 place-items-center rounded-full border border-white/25 text-white/80 hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-white">
            {paused ? <Play className="h-3 w-3" /> : <Pause className="h-3 w-3" />}
          </button>
        )}
      </div>
    </>
  );
}
